import { motion } from "framer-motion";
import { Overline } from "../Reveal";

const steps = [
  { n: "01", title: "Reconocimiento", desc: "Mapeo completo de tu superficie de ataque con OSINT e IA." },
  { n: "02", title: "Explotación controlada", desc: "Simulamos adversarios reales sin poner en riesgo tu operación." },
  { n: "03", title: "Remediación", desc: "Priorizamos y corregimos cada vector con tu equipo, paso a paso." },
  { n: "04", title: "Vigilancia continua", desc: "SOC 24/7 y ciberinteligencia para que la amenaza nunca regrese." },
];

export const Method = () => (
  <section
    id="metodo"
    className="relative mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40"
    data-testid="method"
  >
    <Overline>El Método CYVR</Overline>
    <h2 className="mt-6 max-w-2xl font-head text-4xl font-bold tracking-tight text-white md:text-5xl">
      Precisión operativa en cuatro fases
    </h2>

    <div className="mt-16 grid gap-px border-t border-white/10 md:grid-cols-4">
      {steps.map((s, i) => (
        <motion.div
          key={s.n}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="group relative border-b border-white/10 py-10 md:border-b-0 md:border-r md:px-8 md:last:border-r-0"
          data-testid={`method-step-${i}`}
        >
          <span className="font-mono-tech text-5xl font-bold text-white/10 transition-colors duration-500 group-hover:text-cyber-cyan/40">
            {s.n}
          </span>
          <h3 className="mt-6 font-head text-xl font-semibold text-white">{s.title}</h3>
          <p className="mt-3 font-sans text-sm leading-relaxed text-white/60">{s.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
